import type { HTMLAttributes, MouseEvent, ReactNode, Ref } from "react";
import { forwardRef } from "react";

export interface SidebarRowProps extends Omit<
    HTMLAttributes<HTMLElement>,
    "onClick"
> {
    /** Renders an anchor when given, a button otherwise. */
    href?: string;
    /** Renders neither, so the row can be neither clicked nor focused. */
    locked?: boolean;
    onClick?: (event: MouseEvent<HTMLElement>) => void;
    children: ReactNode;
}

// `forwardRef`, not a `ref` prop: legacy's React 18 drops `ref` props, and
// Radix anchors to it.
export const SidebarRow = forwardRef<HTMLElement, SidebarRowProps>(
    ({ href, locked = false, onClick, ...rest }, ref) => {
        if (locked) {
            return <span ref={ref} aria-disabled {...rest} />;
        }

        return href === undefined ? (
            <button
                ref={ref as Ref<HTMLButtonElement>}
                type="button"
                onClick={onClick}
                {...rest}
            />
        ) : (
            <a
                ref={ref as Ref<HTMLAnchorElement>}
                href={href}
                onClick={onClick}
                {...rest}
            />
        );
    }
);
